import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { TextField, MenuItem } from "@mui/material";
import ShamsiDatePicker from "../../_Components/ShamsiDatePicker";
import { NumericFormat } from "react-number-format";
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from "./DataTable";
import ApiTransaction from "../../../../core/api/api.transaction";
import ApiGallery from "../../../../core/api/api.gallery";
import { tools } from "../../../../core/utils/tools";
import SelectComponent from "../../_Components/ReactSelectComponent";
import ApiSupplier from "../../../../core/api/api.supplier";
import ApiOrdersService from "../../../../core/api/api.ordersService";
import ApiAmusementServiceReserveItem from "../../../../core/api/api.amusementServiceReserveItem";
import ApiAmusementServiceReserveItemGroup from "../../../../core/api/api.amusementServiceReserveItemGroup";
import ApiAmusementGroup from "../../../../core/api/api.amusementGroup";
import GlobalFormControl from "../../_Components/GlobalFormControl";
import ApiRegion from "../../../../core/api/api.region";
import ApiHome from "../../../../core/api/api.home";

const promoCodeEnumArray = [
  { id: "", title: "-----" },
  { id: "1", title: "دارد" },
  { id: "0", title: "ندارد" },
];
const ReportSellBuy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [listData, setListData] = useState({});
  const [isExcel, setIsExcel] = useState(false);

  const [services, setServices] = useState([]);

  const [supplierList, setSupplierList] = useState();

  const [basketItemCurrentStatus, setBasketItemCurrentStatus] = useState([]);
  const [basketCancelStatus, setBasketCancelStatus] = useState([]);
  const [groupedReserveItemsOptions, setGroupedReserveItemsOptions] = useState([]);
  const [group, setGroup] = useState([]);
  const [amusementGroupList, setAmusementGroupList] = useState([]);
  const [isSelectOtherCityElseKish, setIsSelectOtherCityElseKish] = useState(false)
  const [transactionTypes, setTransactionTypes] = useState();

  const [amusementCityList, setAmusementCityList] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        setListData([])
        tools.handleResetAdvanceSearchBox(watch, reset);
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
        let dataList = [];
        //dd.unshift({ value: '0', label: 'همه موارد'  });

        // دریافت لیست همه تامین کننده ها
        const suppliersList = await ApiSupplier.getAllSuppliersName();
        setSupplierList(suppliersList);
        const types = await ApiHome.getEnums({ enumName: "TransactionType" });
        setTransactionTypes(types.data);

        // دریافت لیست  سرویس ها
        //لیست ایتم های وابسته به انتخاب نوع فایل   سرویس ها =1
        let data2 = await ApiGallery.getSelectiveListByGalleryType({ Type: 1 });
        var amusementService = [];
        if (data2.succeeded) {
          amusementService = data2?.data;
          amusementService.unshift({ id: 0, value: "0", title: "همه موارد" });
          setServices(amusementService);
        }
        const resultBasketItemCurrentStatus = await ApiOrdersService.GetEnumsName("BasketItemCurrentStatus");
        setBasketItemCurrentStatus(resultBasketItemCurrentStatus.data);
        const resultBasketCancelStatus = await ApiOrdersService.GetEnumsName("BasketCancelStatus");
        setBasketCancelStatus(resultBasketCancelStatus.data);
        const amusementGroups = await ApiAmusementGroup.getAllGroups();
        setAmusementGroupList(amusementGroups);
        const cities = await ApiRegion.getAllCity();
        const kish = cities.filter(city => city.name == 'کیش').map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        const otherCities = cities.filter(city => city.name != 'کیش' && city.id != 0).map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        setAmusementCityList([
          {
            label: 'شهر های مورد علاقه',
            options: [...kish, { label: "سایر شهرها به جز کیش", value: 0 }]
          },
          {
            label: "همه شهر های ایران",
            options: otherCities
          }
        ]);

        var sellOrBuy = "";
        if (location && location.pathname && location.pathname == "/reportSellTransaction") {
          sellOrBuy = "sell";
        }
        if (location && location.pathname && location.pathname == "/reportBuyTransaction") {
          sellOrBuy = "buy";
        }
        //برای زمانی که در url، queryString داریم
        if (searchParams.size > 0) {
          const apiData = await ApiTransaction.getSellBuyReport({
            pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
            pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
            typeShowResult: searchParams.get("typeShowResult"),
            basketFromCreatedDate: searchParams.get("basketFromCreatedDate"),
            basketToCreatedDate: searchParams.get("basketToCreatedDate"),
            useTimeOf: searchParams.get("useTimeOf"),
            useTimeTo: searchParams.get("useTimeTo"),
            transactionFromCompletionDate: searchParams.get("transactionFromCompletionDate"),
            transactionToCompletionDate: searchParams.get("transactionToCompletionDate"),
            payToWarrantyTimeTo: searchParams.get("payToWarrantyTimeTo"),
            payToWarrantyTimeOf: searchParams.get("payToWarrantyTimeOf"),
            fromAmount: searchParams.get("fromAmount"),
            toAmount: searchParams.get("toAmount"),
            cancelStatus: _.toString(searchParams.get("cancelStatus")),
            currentStatus: _.toString(searchParams.get("currentStatus")),
            cityIds: searchParams.get("cityIds"),
            amusementGroupIds: searchParams.get("amusementGroupIds"),
            amusementServiceIds: searchParams.get("amusementServiceIds"),
            amusementServiceReserveItemIds: searchParams.get("amusementServiceReserveItemIds"),
            amusementServiceReserveItemGroupIds: searchParams.get("amusementServiceReserveItemGroupIds"),
            originalPrice: searchParams.get("originalPrice"),
            salePrice: searchParams.get("salePrice"),
            firstName: searchParams.get("firstName"),
            lastName: searchParams.get("lastName"),
            phoneNumber: searchParams.get("phoneNumber"),
            basketItemPersonOf: searchParams.get("basketItemPersonOf"),
            basketItemPersonTo: searchParams.get("basketItemPersonTo"),
            basketIdOf: searchParams.get("basketIdOf"),
            basketIdTo: searchParams.get("basketIdTo"),
            transactionSupplierIdList: searchParams.get("transactionSupplierIdList"),
            promoCode: searchParams.get("promoCode"),
            orderBySelect: searchParams.get("orderBySelect"),
            globalSearch: searchParams.get("globalSearch"),
            sellOrBuy: sellOrBuy,
            transactionType: searchParams.get("transactionType")
          });
          setListData(apiData);

          const amusementItemIds = searchParams.get("amusementServiceIds")?.split(",") || [];
          const selectedServiceIds = amusementService
            .filter((item) => amusementItemIds.includes(String(item.id)))
            ?.map((item) => ({ label: item.name, value: item.id }));
          const selectedItemsGroupIds = searchParams.get("amusementServiceReserveItemGroupIds")?.split(",") || [];
          const selectedItemsItemIds = searchParams.get("amusementServiceReserveItemIds")?.split(",") || [];
          inputChangeHandlerService(selectedServiceIds, true, selectedItemsGroupIds, selectedItemsItemIds);

          const formInputs = [
            { name: "typeShowResult", type: "text" },
            { name: "basketFromCreatedDate", type: "datePicker" },
            { name: "basketToCreatedDate", type: "datePicker" },
            { name: "useTimeOf", type: "datePicker" },
            { name: "useTimeTo", type: "datePicker" },
            { name: "basketItemPersonOf", type: "text" },
            { name: "basketItemPersonTo", type: "text" },
            { name: "basketIdOf", type: "text" },
            { name: "basketIdTo", type: "text" },
            { name: "firstName", type: "text" },
            { name: "lastName", type: "text" },
            { name: "phoneNumber", type: "text" },
            { name: "amusementServiceIds", type: "multiSelect", isMulti: true, data: data2?.data },
            { name: "cityIds", type: "multiSelect", isMulti: true, data: cities },
            { name: "amusementGroupIds", type: "multiSelect", isMulti: true, data: amusementGroups.data },
            {
              name: "amusementServiceReserveItemGroupIds",
              type: "multiSelectInGroup",
              data: groupedReserveItemsOptions,
            },
            { name: "transactionFromCompletionDate", type: "datePicker" },
            { name: "transactionToCompletionDate", type: "datePicker" },
            { name: "payToWarrantyTimeTo", type: "datePicker" },
            { name: "payToWarrantyTimeOf", type: "datePicker" },
            { name: "fromAmount", type: "text" },
            { name: "toAmount", type: "text" },
            { name: "originalPrice", type: "text" },
            { name: "salePrice", type: "text" },
            { name: "promoCode", type: "multiSelect", isMulti: false, data: promoCodeEnumArray },
            { name: "currentStatus", type: "multiSelect", isMulti: true, data: resultBasketItemCurrentStatus.data },
            { name: "cancelStatus", type: "multiSelect", isMulti: true, data: resultBasketCancelStatus.data },
            { name: "orderBySelect", type: "text" },
            { name: "globalSearch", type: "text" },
            { name: "pageSize", type: "number" },
            { name: "pageNumber", type: "number" },
            { name: "transactionType", type: "text" },
          ];
          tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, [location.pathname]);

  useEffect(() => {
    setAmusementCityList(prev => {
      const otherCities = prev[1]?.options
      const cities = prev[0]?.options
      const disabledOtherCities = otherCities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []
      const disabledCities = cities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []

      return [{ ...prev[0], options: disabledCities }, { ...prev[1], options: disabledOtherCities }]
    })

  }, [getValues("cityIds")])

  function handleChangeMultiCurrentStatus(value) {
    setValue("currentStatus", value);
  }
  function handleChangeMultiCancelStatus(value) {
    setValue("cancelStatus", value);
  }
  const inputChangeHandlerService = async (
    event,
    firstRender = false,
    selectedItemsGroupIds = [],
    selectedItemsItemIds = []
  ) => {
    if (!firstRender) setValue("amusementServiceIds", event);

    if (event.length > 0) {
      const responses = await Promise.all(
        event.map(async ({ value }) => {
          const reserveItems = await ApiAmusementServiceReserveItem.getAllReserveItems(value);
          const reserveItemGroups = await ApiAmusementServiceReserveItemGroup.getAllReserveItemGroups(value);
          return [reserveItems, reserveItemGroups, value];
        })
      );

      let groupedReserveItemsOptions = [];
      let groupedReserveItemGroupOptions = [];
      let itemList = [];
      let groupList = [];

      responses.forEach(([reserveItems, reserveItemGroups, value]) => {
        const label = event.find((item) => item.value == value)?.label;

        const optionsItems = reserveItems.map((item) => ({
          value: item.id,
          label: item.title,
        }));

        const optionsGroups = reserveItemGroups.map((item) => ({
          value: item.id,
          label: item.title,
        }));

        groupedReserveItemsOptions.push({ label, options: optionsGroups }); // گروه آیتم‌ها
        groupedReserveItemGroupOptions.push({ label, options: optionsItems }); // آیتم‌ها

        if (firstRender) {
          const selectedGroupItems = reserveItemGroups
            .filter((item) => selectedItemsGroupIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));

          const selectedItems = reserveItems
            .filter((item) => selectedItemsItemIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));

          itemList.push(...selectedGroupItems);
          groupList.push(...selectedItems);
        }
      });
      setGroupedReserveItemsOptions(groupedReserveItemsOptions);
      setGroup(groupedReserveItemGroupOptions);

      if (firstRender) {
        setValue("amusementServiceReserveItemGroupIds", itemList);
        setValue("amusementServiceReserveItemIds", groupList);
      }
    } else if (event.length === 0) {
      // وقتی هیچ تفریحی انتخاب نشده
      setGroupedReserveItemsOptions([]);
      setGroup([]);
      setValue("amusementServiceReserveItemGroupIds", []);
      setValue("amusementServiceReserveItemIds", []);
    }
  };
  const onSubmit = async (data) => {
    if (data.cityIds?.length > 0) data.cityIds = _.toString(data.cityIds?.map((item) => item.value));
    if (data.transactionSupplierIdList?.length > 0) data.transactionSupplierIdList = _.toString(data.transactionSupplierIdList?.map((item) => item.value));

    if (data.amusementGroupIds?.length > 0) data.amusementGroupIds = _.toString(data.amusementGroupIds?.map((item) => item.value));
    if (!_.isEmpty(data.fromAmount) && !validateNumberFromAmount(data.fromAmount)) return;
    if (!_.isEmpty(data.toAmount) && !validateNumberToAmount(data.toAmount)) return;
    if (!_.isEmpty(data.originalPrice) && !validateNumberOriginalPrice(data.originalPrice)) return;
    if (!_.isEmpty(data.salePrice) && !validateNumberSalePrice(data.salePrice)) return;
    if (!_.isEmpty(data.basketItemPersonOf) && !validateNumberBasketItemPersonOf(data.basketItemPersonOf)) return;
    if (!_.isEmpty(data.basketItemPersonTo) && !validateNumberBasketItemPersonTo(data.basketItemPersonTo)) return;
    if (!_.isEmpty(data.basketIdOf) && !validateNumberBasketIdOf(data.basketIdOf)) return;
    if (!_.isEmpty(data.basketIdTo) && !validateNumberBasketIdTo(data.basketIdTo)) return;

    data.sellOrBuy = "";
    if (location && location.pathname && location.pathname == "/reportSellTransaction") data.sellOrBuy = "sell";
    if (location && location.pathname && location.pathname == "/reportBuyTransaction") data.sellOrBuy = "buy";
    data.promoCode = data.promoCode?.value;
    // data.pageNumber = getValues("pageNumber");
    data.fromAmount =
      data.fromAmount && data.fromAmount.length > 0
        ? data.fromAmount.replaceAll(" ", "").replaceAll(",", "")
        : undefined;
    data.toAmount =
      data.toAmount && data.toAmount.length > 0 ? data.toAmount.replaceAll(" ", "").replaceAll(",", "") : undefined;
    if (data.basketFromCreatedDate && typeof data.basketFromCreatedDate === "object") {
      data.basketFromCreatedDate = tools.DateFormat(data.basketFromCreatedDate);
    }
    if (data.basketToCreatedDate && typeof data.basketToCreatedDate === "object") {
      data.basketToCreatedDate = tools.DateFormat(data.basketToCreatedDate);
    }
    if (data.useTimeOf && typeof data.useTimeOf === "object") {
      data.useTimeOf = tools.DateFormat(data.useTimeOf);
    }
    if (data.useTimeTo && typeof data.useTimeTo === "object") {
      data.useTimeTo = tools.DateFormat(data.useTimeTo);
    }
    if (data.transactionFromCompletionDate && typeof data.transactionFromCompletionDate === "object") {
      data.transactionFromCompletionDate = tools.DateFormat(data.transactionFromCompletionDate);
    }
    if (data.transactionToCompletionDate && typeof data.transactionToCompletionDate === "object") {
      data.transactionToCompletionDate = tools.DateFormat(data.transactionToCompletionDate);
    }
    if (data.payToWarrantyTimeTo && typeof data.payToWarrantyTimeTo === "object") {
      data.payToWarrantyTimeTo = tools.DateFormat(data.payToWarrantyTimeTo);
    }
    if (data.payToWarrantyTimeOf && typeof data.payToWarrantyTimeOf === "object") {
      data.payToWarrantyTimeOf = tools.DateFormat(data.payToWarrantyTimeOf);
    }
    if (!_.isEmpty(data.salePrice)) data.salePrice = data.salePrice.replaceAll(",", "");
    if (!_.isEmpty(data.originalPrice)) data.originalPrice = data.originalPrice.replaceAll(",", "");
    if (data.cancelStatus?.length > 0) data.cancelStatus = _.toString(data.cancelStatus?.map((item) => item.value));
    if (data.currentStatus?.length > 0) data.currentStatus = _.toString(data.currentStatus?.map((item) => item.value));

    if (data.amusementServiceIds?.length > 0)
      data.amusementServiceIds = _.toString(data.amusementServiceIds?.map((item) => item.value));

    if (data.amusementServiceReserveItemGroupIds?.length > 0)
      data.amusementServiceReserveItemGroupIds = _.toString(
        data.amusementServiceReserveItemGroupIds?.map((item) => item.value),
      );

    if (data.amusementServiceReserveItemIds?.length > 0)
      data.amusementServiceReserveItemIds = _.toString(data.amusementServiceReserveItemIds?.map((item) => item.value));
    tools.setPageNumber(data, searchParams, setValue);
    if (isExcel) {
      await ApiTransaction.getSellBuyReportExcel(data).then((response) => {
        const fileBlobUrl = URL.createObjectURL(new Blob([response]));
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.id = "file" + Math.floor(Math.random() * 100);
        anchor.href = fileBlobUrl;
        anchor.download = "Report.xlsx";
        document.body.appendChild(anchor);
        anchor.click();
      });
      setIsExcel(false)
    }
    const apiData = await ApiTransaction.getSellBuyReport(data);
    setListData(apiData);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount", "sellOrBuy"]));
    if (data.sellOrBuy == "sell") navigate(`/reportSellTransaction?${queryString}`);
    else navigate(`/reportBuyTransaction?${queryString}`);


    // setValue("totalCount", apiData.totalCount);
  };
  const validateNumberFromAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("fromAmount", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("fromAmount");
      return true;
    }
  };
  const validateNumberToAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("toAmount", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("toAmount");
      return true;
    }
  };

  const validateNumberOriginalPrice = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("originalPrice", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("originalPrice");
      return true;
    }
  };

  const validateNumberSalePrice = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("salePrice", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("salePrice");
      return true;
    }
  };

  const validateNumberBasketItemPersonOf = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketItemPersonOf", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonOf");
      return true;
    }
  };
  const validateNumberBasketItemPersonTo = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketItemPersonTo", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonTo");
      return true;
    }
  };

  const validateNumberBasketIdOf = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketIdOf", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketIdOf");
      return true;
    }
  };
  const validateNumberBasketIdTo = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketIdTo", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketIdTo");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              گزارش تراکنش های
              {location && location.pathname && location.pathname == "/reportSellTransaction" ? " فروش " : " خرید  "}
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">صورت معاملات دوره ای</span>
          </h3>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0 ">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>

                          <Col sm="6" xl="3" className="  px-2">
                            <Controller
                              name="typeShowResult"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="نوع جستجو"
                                  className="mt-3"
                                  variant="outlined"
                                  margin="normal"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                  onChange={onChange}
                                >
                                  {/* <MenuItem key={99} value={0}>
                                    {" "}
                                    تراکنش{" "}
                                  </MenuItem> */}
                                  <MenuItem key={1} value={"basket"}>
                                    {" "}
                                    سفارش{" "}
                                  </MenuItem>
                                  <MenuItem key={2} value={"basketItem"}>
                                    {" "}
                                    تفریح{" "}
                                  </MenuItem>
                                  <MenuItem key={3} value={"basketItemPerson"}>
                                    {" "}
                                    بلیط{" "}
                                  </MenuItem>
                                </TextField>
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="  px-2">
                            <Controller
                              name="orderBySelect"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="مرتب سازی بر اساس "
                                  className="mt-3"
                                  variant="outlined"
                                  margin="normal"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                  onChange={onChange}
                                >
                                  <MenuItem key={99} value={0}>
                                    {" "}
                                    پیش فرض{" "}
                                  </MenuItem>
                                  <MenuItem key={1} value={"basket"}>
                                    {" "}
                                    شماره سفارش{" "}
                                  </MenuItem>
                                  <MenuItem key={2} value={"basketItem"}>
                                    {" "}
                                    شماره ایتم سفارش{" "}
                                  </MenuItem>
                                  <MenuItem key={3} value={"basketItemPerson"}>
                                    {" "}
                                    شماره بلیط{" "}
                                  </MenuItem>
                                  <MenuItem key={4} value={"basketCreated"}>
                                    {" "}
                                    تاریخ ثبت سفارش{" "}
                                  </MenuItem>
                                  <MenuItem key={5} value={"basketItemCheckInDate"}>
                                    {" "}
                                    تاریخ تفریح{" "}
                                  </MenuItem>
                                  <MenuItem key={6} value={"basketItemAmusementServiceNmae"}>
                                    {" "}
                                    نام تفریح{" "}
                                  </MenuItem>
                                  <MenuItem key={7} value={"sumAmount"}>
                                    {" "}
                                    مبلغ{" "}
                                  </MenuItem>
                                  <MenuItem key={8} value={"completionDate"}>
                                    {" "}
                                    زمان خرید{" "}
                                  </MenuItem>
                                  <MenuItem key={9} value={"type"}>
                                    {" "}
                                    نوع تراکنش{" "}
                                  </MenuItem>
                                  <MenuItem key={10} value={"transactionId"}>
                                    {" "}
                                    شماره تراکنش{" "}
                                  </MenuItem>
                                </TextField>
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className=" px-2 mt-3">
                            <Controller
                              name="basketFromCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  // label=' از تاریخ ثبت سفارش '
                                  placeholder=" از تاریخ ثبت سفارش "
                                  onChange={(date) => {
                                    var basketToCreatedDate = getValues("basketToCreatedDate");
                                    onChange(date);
                                    if (
                                      !basketToCreatedDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(basketToCreatedDate).getTime())
                                    ) {
                                      // Set the value of basketToCreatedDate to the same as basketToCreatedDate
                                      setValue("basketToCreatedDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className=" px-2 mt-4">
                            <Controller
                              name="basketToCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={onChange}
                                  // label='تا تاریخ ایجاد سبد'
                                  placeholder="تا تاریخ  ثبت سفارش"
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className=" px-2 mt-4">
                            <Controller
                              name="useTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  // label=' از تاریخ انجام تفریح'
                                  placeholder=" از تاریخ انجام تفریح"
                                  onChange={(date) => {
                                    var useTimeTo = getValues("useTimeTo");
                                    onChange(date);
                                    if (!useTimeTo || (date?.toDate && date?.toDate()?.getTime() > new Date(useTimeTo).getTime())) {
                                      // Set the value of useTimeTo to the same as useTimeTo
                                      setValue("useTimeTo", date);
                                    }
                                  }}
                                />
                              )}
                            />

                          </Col>
                          <Col sm="6" xl="3" className=" px-2 mt-4">
                            <Controller
                              name="useTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={onChange}
                                  // label='تا تاریخ انجام تفریح'
                                  placeholder="تا تاریخ انجام تفریح"
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className=" px-2 mt-4">
                            <Controller
                              name="transactionFromCompletionDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  // label=' از تاریخ موثر تراکنش'
                                  placeholder=" از تاریخ موثر تراکنش"
                                  onChange={(date) => {
                                    onChange(date);
                                    var toCompletionDate = getValues("transactionToCompletionDate");
                                    if (
                                      !toCompletionDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCompletionDate).getTime())
                                    ) {
                                      // Set the value of toCompletionDate to the same as toCompletionDate
                                      setValue("transactionToCompletionDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className=" px-2 mt-4">
                            <Controller
                              name="transactionToCompletionDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={onChange}
                                  // label='تا تاریخ موثر تراکنش'
                                  placeholder="تا تاریخ موثر تراکنش"
                                />
                              )}
                            />
                          </Col>
                          {location.pathname == "/reportBuyTransaction" && <Col sm="6" xl="3" className=" px-2 mt-4">
                            <Controller
                              name="payToWarrantyTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  // label=' از تاریخ موثر تراکنش'
                                  placeholder="از تاریخ پرداخت به تامین کننده"
                                  onChange={(date) => {
                                    onChange(date);
                                    var toCompletionDate = getValues("payToWarrantyTimeTo");
                                    if (
                                      !toCompletionDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCompletionDate).getTime())
                                    ) {
                                      // Set the value of toCompletionDate to the same as toCompletionDate
                                      setValue("payToWarrantyTimeTo", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          }
                          {location.pathname == "/reportBuyTransaction" && <Col sm="6" xl="3" className=" px-2 mt-4">
                            <Controller
                              name="payToWarrantyTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={onChange}
                                  // label='تا تاریخ موثر تراکنش'
                                  placeholder="تا تاریخ پرداخت به تامین کننده"
                                />
                              )}
                            />
                          </Col>
                          }
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="fromAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="از مبلغ"
                                  className="mt-5"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  type="search"
                                  //prefix=" تومان "
                                  error={!!errors.fromAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberFromAmount(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.fromAmount && (
                              <div className="text-small-1 text-danger"> {errors.fromAmount.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="toAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="تا مبلغ"
                                  size="small"
                                  className="mt-5"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  type="search"
                                  //prefix=" تومان "
                                  error={!!errors.toAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberToAmount(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.toAmount && (
                              <div className="text-small-1 text-danger"> {errors.toAmount.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="basketItemPersonOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  className="mt-5"
                                  label="شماره بلیط از "
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  type="search"
                                  error={!!errors.basketItemPersonOf}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonOf(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonOf && (
                              <div className="text-small-1 text-danger"> {errors.basketItemPersonOf.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="basketItemPersonTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره بلیط تا "
                                  className="mt-5"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  type="search"
                                  error={!!errors.basketItemPersonTo}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonTo(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonTo && (
                              <div className="text-small-1 text-danger"> {errors.basketItemPersonTo.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="basketIdOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره سفارش از"
                                  className="mt-4"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  type="search"
                                  error={!!errors.basketIdOf}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketIdOf(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketIdOf && (
                              <div className="text-small-1 text-danger"> {errors.basketIdOf.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="basketIdTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره سفارش تا"
                                  className="mt-4"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  type="search"
                                  error={!!errors.basketIdTo}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketIdTo(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketIdTo && (
                              <div className="text-small-1 text-danger"> {errors.basketIdTo.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="cityIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-4"
                                  placeholder="شهر"
                                  options={amusementCityList}
                                  isMulti
                                  field={field}
                                  onChange={(selectedCities) => {
                                    let confirmValues = selectedCities;
                                    if (selectedCities.find(item => item.value == 0)) {
                                      setIsSelectOtherCityElseKish(true)
                                      confirmValues = selectedCities.filter(city => city.value == 0)
                                    }
                                    else
                                      setIsSelectOtherCityElseKish(false)
                                    field.onChange(confirmValues)
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2 ">
                            <Controller
                              name="amusementGroupIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className=" mt-4"
                                  placeholder=" دسته تفریح"
                                  options={amusementGroupList?.map((item) => ({ value: item.id, label: item.title }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="  px-2">
                            <Controller
                              name="amusementServiceIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-4"
                                  placeholder="تفریح"
                                  options={services?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  field={field}
                                  onChange={(e) => inputChangeHandlerService(e)}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="  px-2">
                            <Controller
                              name="amusementServiceReserveItemGroupIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-4"
                                  placeholder="گروه آیتم"
                                  options={groupedReserveItemsOptions || []}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="  px-2">
                            <Controller
                              name="amusementServiceReserveItemIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-4"
                                  placeholder="آیتم"
                                  options={group || []}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="transactionType"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="نوع تراکنش "
                                  className="mt-4"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                  onChange={onChange}
                                //defaultValue = {4}
                                >
                                  <MenuItem key={0} value={undefined}>
                                    {" "}
                                    --{" "}
                                  </MenuItem>
                                  {transactionTypes?.map((item, index) => (
                                    <MenuItem key={index} value={item.id}>
                                      {item.title}{" "}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              )}
                            />
                          </Col>

                          {location.pathname == "/reportBuyTransaction" &&
                            <>
                              <Col sm="6" xl="3" className=" px-2 mt-4">
                                <Controller
                                  name="cancelStatus"
                                  control={control}
                                  rules={{}}
                                  render={({ field }) => (
                                    <SelectComponent
                                      className="mt-0"
                                      placeholder="وضعیت کنسل"
                                      options={basketCancelStatus?.map((item) => ({
                                        value: item.id,
                                        label: item.id + "-" + item.title,
                                      }))}
                                      field={field}
                                      onChange={handleChangeMultiCancelStatus}
                                      isMulti
                                    />
                                  )}
                                />
                              </Col>
                              <Col sm="6" xl="3" className="px-2">
                                <Controller
                                  name="transactionSupplierIdList"
                                  control={control}
                                  // rules={{ required: true, }}
                                  render={({ field }) => (
                                    <SelectComponent
                                      options={supplierList?.map((item) => ({
                                        value: item.id,
                                        label: item.companyName,
                                      }))}
                                      placeholder="تامین کننده"
                                      className="mt-4"
                                      field={field}
                                      isMulti
                                    />
                                  )}
                                />
                              </Col>
                            </>
                          }
                          {/* <Col
                                sm="6"
                                xl="3"
                                className=" px-2 mt-3
                              "
                              >
                                <Controller
                                  name="systemAccountId"
                                  control={control}
                                  // rules={{ required: true }}
                                  render={({ field: { onChange, value } }) => (
                                    <TextField
                                      select
                                      label=" حساب داخلی"
                                      className="my-2"
                                      variant="outlined"
                                      margin="normal"
                                      size="small"
                                      value={value || ""}
                                      onChange={onChange}
                                    >
                                      <MenuItem key={99} value={undefined}>
                                        {" "}
                                        --{" "}
                                      </MenuItem>
                                      {samanehAccounts?.data?.map((item, index) => (
                                        <MenuItem key={index} value={item.id}>
                                          {" "}
                                          {item.accountOwnerName + "-- " + item.bank + "-- " + item.accountNumber}{" "}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  )}
                                />
                              </Col> */}

                          {/* <Col sm="6" xl="3" className=" px-2">
                                <Controller
                                  name="supplierAccountId"
                                  control={control}
                                  //rules={{ required: true }}
                                  render={({ field: { onChange, value } }) => (
                                    <TextField
                                      select
                                      label="حساب تامین کننده"
                                      className="mb-0 "
                                      variant="outlined"
                                      margin="normal"
                                      size="small"
                                      value={value || ""}
                                      onChange={onChange}
                                    >
                                      <MenuItem key={99} value={undefined}>
                                        {" "}
                                        --{" "}
                                      </MenuItem>
                                      {supplierAccount?.map((item, index) => (
                                        <MenuItem key={index} value={item.id}>
                                          {" "}
                                          {item.accountOwnerName + "-- " + item.bank + "-- " + item.accountNumber}{" "}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  )}
                                />
                              </Col> */}
                          {location && location.pathname && location.pathname == "/reportSellTransaction" && (
                            <>
                              <Col sm="6" xl="3" className=" px-2 mt-5">
                                <Controller
                                  name="currentStatus"
                                  control={control}
                                  render={({ field }) => (
                                    <SelectComponent
                                      className="mt-0"
                                      placeholder="وضعیت سفارش"
                                      options={[
                                        {
                                          value: "0,2",
                                          label: "0-جدید و 2-رهاسازی",
                                        },
                                        ...basketItemCurrentStatus
                                          .filter((item) => item.id != 0 && item.id != 2)
                                          .map((item) => ({
                                            value: item.id,
                                            label: item.id + "-" + item.title,
                                          })),
                                      ]}
                                      onChange={handleChangeMultiCurrentStatus}
                                      field={field}
                                      isMulti
                                    />
                                  )}
                                />
                              </Col>
                              <Col sm="6" xl="3" className=" px-2 mt-5">
                                <Controller
                                  name="cancelStatus"
                                  control={control}
                                  rules={{}}
                                  render={({ field }) => (
                                    <SelectComponent
                                      className="mt-0"
                                      placeholder="وضعیت کنسل"
                                      options={basketCancelStatus?.map((item) => ({
                                        value: item.id,
                                        label: item.id + "-" + item.title,
                                      }))}
                                      field={field}
                                      onChange={handleChangeMultiCancelStatus}
                                      isMulti
                                    />
                                  )}
                                />
                              </Col>
                              <Col sm="6" xl="3" className=" px-2">
                                <Controller
                                  name="originalPrice"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <NumericFormat
                                      customInput={TextField}
                                      label="نرخ مصوب "
                                      size="small"
                                      margin="normal"
                                      value={value || ""}
                                      variant="outlined"
                                      thousandSeparator=","
                                      type="search"
                                      error={!!errors.originalPrice}
                                      onValueChange={(values) => {
                                        onChange(values.value || "");
                                        validateNumberOriginalPrice(values.value);
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === "Escape") {
                                          e.stopPropagation()
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.originalPrice && (
                                  <div className="text-small-1 text-danger"> {errors.originalPrice.message}</div>
                                )}
                              </Col>
                              <Col sm="6" xl="3" className=" px-2">
                                <Controller
                                  name="salePrice"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <NumericFormat
                                      customInput={TextField}
                                      label="نرخ فروش "
                                      size="small"
                                      margin="normal"
                                      value={value || ""}
                                      variant="outlined"
                                      thousandSeparator=","
                                      type="search"
                                      error={!!errors.salePrice}
                                      onValueChange={(values) => {
                                        onChange(values.value || "");
                                        validateNumberSalePrice(values.value);
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === "Escape") {
                                          e.stopPropagation()
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.salePrice && (
                                  <div className="text-small-1 text-danger"> {errors.salePrice.message}</div>
                                )}
                              </Col>
                              <Col sm="6" xl="3" className=" px-2">
                                <Controller
                                  name="firstName"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <TextField
                                      label="نام"
                                      margin="normal"
                                      variant="outlined"
                                      size="small"
                                      value={value || ""}
                                      onInput={onChange}
                                    />
                                  )}
                                />
                              </Col>
                              <Col sm="6" xl="3" className=" px-2">
                                <Controller
                                  name="lastName"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <TextField
                                      label="نام خانوادگی"
                                      margin="normal"
                                      variant="outlined"
                                      size="small"
                                      value={value || ""}
                                      onInput={onChange}
                                    />
                                  )}
                                />
                              </Col>

                              <Col sm="6" xl="3" className=" px-2">
                                <Controller
                                  name="phoneNumber"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <NumericFormat
                                      customInput={TextField}
                                      label="شماره موبایل"
                                      size="small"
                                      margin="normal"
                                      value={value || ""}
                                      variant="outlined"
                                      onChange={onChange}
                                      onKeyDown={(e) => {
                                        if (e.key === "Escape") {
                                          e.stopPropagation()
                                        }
                                      }}
                                    />
                                  )}
                                />
                              </Col>
                              <Col sm="6" xl="3" className=" px-2 mt-5">
                                <Controller
                                  name="promoCode"
                                  control={control}
                                  rules={{}}
                                  render={({ field }) => (
                                    <SelectComponent
                                      className="mt-0"
                                      placeholder="کد تخفیف"
                                      options={promoCodeEnumArray?.map((item) => ({
                                        value: item.id,
                                        label: item.title,
                                      }))}
                                      field={field}
                                    />
                                  )}
                                />
                              </Col>
                            </>
                          )}
                        </Row>

                        <Row>
                          <Col xs="12" className=" px-2 mt-3">
                            <Button
                              variant="success"
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsSelectOtherCityElseKish(false)
                                tools.handleResetAdvanceSearchBox(watch, reset);
                                setListData([])
                              }}
                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                            <Button
                              className="ml-4"
                              variant="info"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(true);
                              }}
                            >
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <InsertDriveFile /> فایل اکسل
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className=" px-0">
                {/* <DataGrid data={listData} /> */}
                <DataTable data={listData} />
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default ReportSellBuy;
